<template>
    <div class="locked-screen">
        <img
            src="/apotheke_clean_02-voll.png"
            alt="Apotheke"
            class="pharmacy-background"
        />
        <div class="locked-card">
            <h1 class="locked-title">Glückwunsch</h1>
            <div class="locked-subtitle">Du hast alle Fragen bereits beantwortet. Schau morgen nochmal vorbei.</div>
        </div>
    </div>
</template>

<style scoped>
    .locked-screen {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        box-sizing: border-box;
    }

    .pharmacy-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        z-index: 1;
    }

    .locked-card {
        position: relative;
        z-index: 2;
        background: #007f96;
        border-radius: 24px;
        padding: 30px 20px;
        text-align: center;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        animation: slideIn 0.5s ease-out;
        max-width: 380px;
        color: #fff;
    }

    .locked-title {
        color: #fff;
        font-size: 40px;
        font-weight: 700;
        margin: 0 0 26px 0;
    }

    .locked-subtitle {
        color: #fff;
        font-size: 25px;
        font-weight: 500;
        margin: 8px 0 10px 0;
    }

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-30px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
